(() => {
  const ROOT_ATTR = 'data-pn';
  const MOTION_ATTR = 'data-pn-motion';
  const STATIC_ATTR = 'data-pn-static';
  const RETRY_MS = 80;
  const RETRY_MAX = 40;

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showStatic = (root) => {
    if (root) root.setAttribute(STATIC_ATTR, '');
  };

  const destroyMotion = (root) => {
    if (!root) return;
    if (root._pnRetry) {
      window.clearTimeout(root._pnRetry);
      root._pnRetry = null;
    }
    if (root._pnCtx) {
      root._pnCtx.revert();
      root._pnCtx = null;
    }
    root.removeAttribute(MOTION_ATTR);
    root.removeAttribute(STATIC_ATTR);
  };

  const playScope = (root, scope) => {
    if (!scope) return;
    const heading = root.querySelector('[data-pn-heading]');
    const cards = scope.querySelectorAll('[data-pn-card]');
    if (!heading && !cards.length) return;

    const parts = [];
    if (heading) parts.push(heading);
    cards.forEach((card) => parts.push(card));

    gsap.set(parts, { autoAlpha: 0, y: 12 });
    gsap.to(parts, {
      autoAlpha: 1,
      y: 0,
      duration: 0.4,
      stagger: 0.04,
      ease: 'power1.out',
      clearProps: 'transform',
      scrollTrigger: {
        trigger: root,
        start: 'top 90%',
        once: true
      }
    });
  };

  const setupMotion = (root, attempt) => {
    if (!root || root.hasAttribute(MOTION_ATTR)) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if ((attempt || 0) < RETRY_MAX) {
        root._pnRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
        return;
      }
      showStatic(root);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    root.setAttribute(MOTION_ATTR, '');

    if (prefersReducedMotion()) {
      showStatic(root);
      return;
    }

    root._pnCtx = gsap.context(() => {
      const mm = gsap.matchMedia();
      mm.add('(min-width: 750px)', () => {
        playScope(root, root.querySelector('.policy-desktop'));
      });
      mm.add('(max-width: 749px)', () => {
        playScope(root, root.querySelector('.policy-mobile-slide'));
      });
    }, root);
  };

  const scan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach((root) => setupMotion(root, 0));
  };

  const rescan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach(destroyMotion);
    scan();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(`[${ROOT_ATTR}]`);
    if (root) destroyMotion(root);
  });
})();
